import { Component, ViewChild, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { getCookie } from '../../../utils/getCookies';
import { ModalGeneralComponent } from '../../user/modals/modal-general/modal-general.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-company-settings',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    MatSelectModule,
    ReactiveFormsModule
  ],
  templateUrl: './company-settings.component.html',
  styleUrl: './company-settings.component.scss'
})
export class CompanySettingsComponent {

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  selectedFile!: File;
  currentPassword!: string;
  newPassword!: string;
  errorPass: any = false;
  language: string = localStorage.getItem('language_conectio_client') || 'es';

  constructor(private http: HttpClient, private router: Router, public dialog: MatDialog, private translate: TranslateService, @Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
    this.language = localStorage.getItem('language_conectio_client') || 'es';
  }

  image: any = localStorage.getItem('profile_image_company') || 'public/anonimo.jpg';
  currentProfileImageUrl: string = environment.url + "/" + this.image ;  // Replace with your current profile image URL or logic to fetch it

  

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event) {

    this.selectedFile = (event.target as HTMLInputElement).files![0];

    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      // Logic to handle the file upload or display a preview
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.currentProfileImageUrl = e.target.result;  // Preview the new image
      };
      reader.readAsDataURL(file);
    }
  }

  onUpload(): void {
    if (this.selectedFile) {
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${getCookie('access_token')}`
      });

      const formData: FormData = new FormData();
      formData.append('image', this.selectedFile, this.selectedFile.name);

      this.http.post<any>(`${environment.url}/api/v1/company/update_image`, formData, { headers: headers })
        .subscribe(
          response => {
            this.dialog.open(ModalGeneralComponent, {
              data: {
                title: this.translate.instant('companySettings.modals.imageUpdated.title'),
                message: this.translate.instant('companySettings.modals.imageUpdated.message'),
                buttonText: this.translate.instant('companySettings.modals.imageUpdated.buttonText'),
                type: 'success'
              }
            });
            this.currentProfileImageUrl = environment.url + "/" + response['image_url'];
            localStorage.setItem('profile_image_company', response['image_url']);
          },
          error => {
            this.dialog.open(ModalGeneralComponent, {
              data: {
                title: this.translate.instant('companySettings.modals.imageError.title'),
                message: this.translate.instant('companySettings.modals.imageError.message'),
                buttonText: this.translate.instant('companySettings.modals.imageError.buttonText'),
                type: 'error'
              }
            });
            console.error('Error updating image', error);
          }
        );
    }
  }

  changePassword(): void {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getCookie('access_token')}`
    });

    const data = {
      "current_password": this.currentPassword,
      "new_password": this.newPassword
    };

    this.http.post<any>(`${environment.url}/api/v1/company/change_password_settings`, data, { headers: headers })
      .subscribe(
        response => {
          this.errorPass = false;
          this.currentPassword = "";
          this.newPassword = "";
          this.dialog.open(ModalGeneralComponent, {
            data: {
              title: this.translate.instant('companySettings.modals.passwordUpdated.title'),
              message: this.translate.instant('companySettings.modals.passwordUpdated.message'),
              buttonText: this.translate.instant('companySettings.modals.passwordUpdated.buttonText'),
              type: 'success'
            }
          });
        },
        error => {
          if (error.status == 401) {
            this.dialog.open(ModalGeneralComponent, {
              data: {
                title: this.translate.instant('companySettings.modals.passwordError.title'),
                message: this.translate.instant('companySettings.modals.passwordError.message'),
                buttonText: this.translate.instant('companySettings.modals.passwordError.buttonText'),
                type: 'error'
              }
            });

          }
          else {
            this.errorPass = true;
            this.dialog.open(ModalGeneralComponent, {
              data: {
                title: this.translate.instant('companySettings.modals.passwordUpdateError.title'),
                message: this.translate.instant('companySettings.modals.passwordUpdateError.message'),
                buttonText: this.translate.instant('companySettings.modals.passwordUpdateError.buttonText'),
                type: 'error'
              }
            });
          }
        }
      );
  }

  logout(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('profile_image');
    localStorage.removeItem('can_see_tree');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
    localStorage.removeItem('profile_name');
    document.cookie = `access_token=; path=/;`;
    document.cookie = `company_name=; path=/;`;
    this.router.navigate(['/company/login']);
  }

  cambiarIdioma(event: any) {

    let lang = event;

    this.translate.use(lang);

    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('language_conectio_client', lang);
      if (getCookie('access_token')) {
        this.http.post(`${environment.url}/api/v1/company/set_language`, {
          language: lang
        }, {
          headers: {
            'Authorization': `Bearer ${getCookie('access_token')}`
          }
        }).subscribe((data: any) => {
          console.log(data);
        });
      } else {
        localStorage.setItem('language_conectio_client', lang);
      }
    }
  }
  
}
